/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Sync_Twda_DescInputs */



/**
* | output |
* | --- |
* | "Import winning decklists from the TWDA. Runs automatically every 24 hours." |
*
* @param {Admin_Sync_Twda_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const admin_sync_twda_desc = /** @type {((inputs?: Admin_Sync_Twda_DescInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Sync_Twda_DescInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Importe les listes de decks gagnants depuis la TWDA. S'exécute automatiquement toutes les 24 heures.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Importa las listas de mazos ganadores desde la TWDA. Se ejecuta automáticamente cada 24 horas.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Importa as listas dos decks vencedores da TWDA. Executado automaticamente a cada 24 horas.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importa le liste dei deck vincitori dalla TWDA. Viene eseguita automaticamente ogni 24 ore.")
	return /** @type {LocalizedString} */ ("Import winning decklists from the TWDA. Runs automatically every 24 hours.")
});